import { css, selectTheme, styled } from '@creditas-ui/react';
import type { Property } from 'csstype';

interface TableBodyProps {
  striped?: boolean;
  stripedColorEven?: Property.Color;
  stripedColorOdd?: Property.Color;
}

export const TableCell = styled.td<{
  textAlign?: Property.TextAlign;
}>`
  padding: ${selectTheme('spacingY.lg')};
  font-size: ${selectTheme('fontSizes.md')};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'center')};
  vertical-align: middle;
  color: ${selectTheme('colors.neutral.90')};
  font-family: 'Helvetica Now Display';
`;

export const THeadCell = styled(TableCell)`
  padding: ${selectTheme('spacingY.lg')};
  font-size: ${selectTheme('fontSizes.md')};
  text-align: 'center';
  vertical-align: middle;
`;

THeadCell.defaultProps = {
  as: 'th',
};

export const TableBody = styled.tbody<TableBodyProps>`
  ${({ striped, stripedColorOdd = 'transparent', stripedColorEven = 'red' }) =>
    striped &&
    css`
      tr:nth-of-type(even) td {
        background-color: ${stripedColorEven};
      }
      tr:nth-of-type(odd) td {
        background-color: ${stripedColorOdd};
      }
    `}
`;

export const Table = styled.table<{ display: 'table' | 'none' }>`
  border-spacing: 0;
  display: ${({ display }) => display};
  width: -webkit-fill-available;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${selectTheme('colors.neutral.10')};
  &:hover td {
    background-color: ${selectTheme('colors.neutral.10')};
  }
`;

export const TableHead = styled.thead`
  inset-block-start: 0;
  th {
    position: sticky;
    top: 11em;
    z-index: 2;
    background-color: rgb(255, 255, 255);
  }
  ,
  td {
    padding: 16px 0 18px ${selectTheme('spacingY.lg')};
    font-weight: ${selectTheme('fontWeight.lg')};
    font-size: ${selectTheme('fontSizes.lg')};
    color: ${selectTheme('colors.neutral.60')};
  }
`;

export const EmptyCell = () => <TableCell>-</TableCell>;
